import { DynamicPromoShow, LiveShow, MediaShow, Show } from "../../domain/show";

export class CalendarItem {
  public ads = 3;
  public graphics = 5;
  public height: number;
  public topForColumn: number[] = [];
  public isDragged = false;
  public isDropped = false;

  constructor(public items: Show[]) {}

  pushShow(item: Show) {
    this.items.push(item);
  }

  get itemName() {
    if (this.items.length > 1) {
      return "Multiple Items";
    }
    return this.items[0].name;
  }

  get endTime() {
    return this.items[this.items.length - 1].endTime.clone();
  }

  get startTime() {
    return this.items[0].startTime.clone();
  }

  get showId() {
    if (this.items.length > 1) {
      return "";
    }
    return this.items[0].id;
  }

  get show(): Show {
    if (this.items.length > 1) {
      return null;
    }
    return this.items[0];
  }

  get mediaId() {
    if (this.items.length > 1) {
      return "";
    }
    if (!(this.items[0] instanceof MediaShow)) {
      return "";
    }
    return (<MediaShow>this.items[0]).mediaId;
  }
  get isMediaShow(): boolean {
    // tslint:disable-next-line:radix
    return isNaN(parseInt(this.mediaId.toString())) === false;
  }

  get promoId() {
    if (this.items.length > 1) {
      return "";
    }
    if (!(this.items[0] instanceof DynamicPromoShow)) {
      return "";
    }
    return (<DynamicPromoShow>this.items[0]).promoId;
  }

  get feedId() {
    if (this.items.length > 1) {
      return "";
    }
    if (!(this.items[0] instanceof LiveShow)) {
      return "";
    }
    return (<LiveShow>this.items[0]).feedId;
  }

  get thumbnailUrl() {
    if (this.items.length > 1) {
      return "";
    }
    return this.items[0].thumbnailUrl;
  }

  get subtitles() {
    if (this.items.length > 1) {
      return [];
    }
    if (!(this.items[0] instanceof MediaShow)) {
      return [];
    }
    return (<MediaShow>this.items[0]).subtitles;
  }
}
